import { render, staticRenderFns } from "./feeSettings.vue?vue&type=template&id=820968f0&scoped=true"
import script from "./feeSettings.vue?vue&type=script&lang=js"
export * from "./feeSettings.vue?vue&type=script&lang=js"
import style0 from "./feeSettings.vue?vue&type=style&index=0&id=820968f0&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820968f0",
  null
  
)

export default component.exports